/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable default-case */
export type putUserValidType = {
  name: {
    message: string;
    errorFlag: boolean;
  };
  password: {
    message: string;
    errorFlag: boolean;
  };
  departmentName: {
    message: string;
    errorFlag: boolean;
  };
  phoneNumber: {
    message: string;
    errorFlag: boolean;
  };
};

export const initPutUserValid = {
  name: {
    message: '',
    errorFlag: false,
  },
  password: {
    message: '',
    errorFlag: false,
  },
  departmentName: {
    message: '',
    errorFlag: false,
  },
  phoneNumber: {
    message: '',
    errorFlag: false,
  },
};

export class PutChangeUserValidation {
  private putUserErr: putUserValidType = {
    name: {
      message: '',
      errorFlag: false,
    },
    password: {
      message: '',
      errorFlag: false,
    },
    departmentName: {
      message: '',
      errorFlag: false,
    },
    phoneNumber: {
      message: '',
      errorFlag: false,
    },
  };

  setErrorMassage(messages: []): void {
    messages.forEach((message: any) => {
      switch (message.loc[0]) {
        case 'name':
          this.putUserErr.name.message = message.message;
          this.putUserErr.name.errorFlag = true;
          break;
        case 'password':
          this.putUserErr.password.message = message.message;
          this.putUserErr.password.errorFlag = true;
          break;
        case 'department_name':
          this.putUserErr.departmentName.message = message.message;
          this.putUserErr.departmentName.errorFlag = true;
          break;
        case 'phone_number':
          this.putUserErr.phoneNumber.message = message.message;
          this.putUserErr.phoneNumber.errorFlag = true;
          break;
      }
    });
  }

  getObj(): putUserValidType {
    return this.putUserErr;
  }
}
